<template>
	<div class="self-start">
		<div id="back">
			<router-link to="/">
				<i class="times dark"></i>
			</router-link>
		</div>

		<div class="container">
			<div class="flex flex-wrap justify-between">
				<div class="w-full md:w-1/2">
					<img class="mb-20 md:hidden mt-20" src="/pig-art.svg" alt="Pig" width="400" />

					<h2 class="text-orange text-3xl font-semibold mt-20 mb-12">
						What I love: Leading the exploration and design of new perspectives that improve user experiences and team efficiencies.

						<br />
						<br />

						What I love even more:  The joys of parenting (even picking up sticky things that most people would back away from).
					</h2>

					<h6 class="font-barlow text-orange uppercase font-bold mb-4">Profile</h6>
					<p>
						<em>
							“The details are not the details. They make the design.”
							<br />
							~ Charles Eames
						</em>
					</p>

					<p>Simply put, sweating the details is in my DNA. I’m an experienced, senior UX/UI designer who leads by example. I actively mentor other designers on how to meet user needs through context, empathy and goal accomplishment.</p>

					<h6 class="font-barlow text-orange uppercase font-bold mb-4">Career Hilights</h6>
					<p><strong>Ellie Mae:</strong> I currently manage a web design team for the premier technology provider in the home mortgage industry. I am chiefly responsible for creating a design system that incorporates brand guidelines and assets, a living UI kit, and a block system of stackable components for present and future web properties.</p>
					<p><strong>Viewpost:</strong> I was responsible for leading the redesign of an interactive UI dashboard for an innovative provider of B2B financial solutions. This dashboard became a true hub of customer activity, providing real-time views of business accounting and cash flow.</p>
					<p><strong>Hundred10:</strong> I served as co-founder and Art Director for a successful digital agency that produced iOS apps, responsive websites and interactive portals for local, national and international clients.</p>


					<div class="card bg-green text-white mb-12 rounded md:hidden">
						<h6 class="font-barlow text-orange uppercase font-bold mb-4 px-8 py-4 border-b border-gray-700">What Drives Me</h6>

						<div class="mb-4 px-8 py-4">
							<p>Evoking emotion through better product design and brand communications</p>
							<p>Collaborating with product engineers to ensure consistent and meaningful user experiences</p>
							<p>Creating systematic approaches to understanding user problem spaces, and designing engaging solutions to those issues</p>
							<p>Almost everything from McDonald’s and Long John Silver’s is amazing</p>
						</div>
					</div>

					<div class="flex flex-wrap">
						<div class="w-full xl:w-1/2 pr-20">
							<h6 class="font-barlow text-orange uppercase font-bold mb-4">Tangibles</h6>
							<ul class="mb-8">
								<li class="mb-4">Over 20 years experience in product UI/UX design, web design and corporate identity</li>
								<li class="mb-4">Progressive knowledge of front end and iOS development</li>
								<li class="mb-4">Expert mastery of popular design tools</li>
							</ul>
						</div>
						<div class="w-full xl:w-1/2 pr-20">
							<h6 class="font-barlow text-orange uppercase font-bold mb-4">Intangibles</h6>
							<ul class="mb-8">
								<li class="mb-4">Effective communicator, manager, mentor and team builder</li>
								<li class="mb-4">Committed to quality, efficiency and awareness</li>
								<li class="mb-4">Team player, at home in truly collaborative environments</li>
							</ul>
						</div>
					</div>

					<div class="border-t my-20 pt-8">
						<a href="mailto:jmilly@me.com"><img class="inline-block mr-8" src="email.svg" alt="Download Resume" ></a>
						<a href="https://www.linkedin.com/in/johnmilly" target="_blank"><img class="inline-block mr-8" src="linkedin.svg" alt="Download Resume" ></a>
						<a href="jm-resume-2019.pdf" target="_blank"><img class="inline-block mr-8" src="pdf.svg" alt="Download Resume" ></a>
					</div>
				</div>

				<div class="w-full md:w-1/3 mt-12 hidden md:inline">
					<img class="mb-20" src="/pig-art.svg" alt="Pig" />

					<div class="card bg-green text-white rounded">
						<h6 class="font-barlow text-orange uppercase font-bold mb-4 px-8 py-4 border-b border-gray-700">What Drives Me</h6>

						<div class="mb-4 px-8 py-4">
							<p>Evoking emotion through better product design and brand communications</p>
							<p>Collaborating with product engineers to ensure consistent and meaningful user experiences</p>
							<p>Creating systematic approaches to understanding user problem spaces, and designing engaging solutions to those issues</p>
							<p>Almost everything from McDonald’s and Long John Silver’s is amazing</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapMutations } from 'vuex';

export default {
	components: {},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
	},
	created: function() {
		this.APP_CLASS('page-about');
	}
}
</script>